var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"margin-top-xs"},[_c('span',{staticClass:"firstTitle"},[_c('i'),_vm._v(_vm._s(_vm.title))]),_c('dv-scroll-board',{staticClass:"margin-top-sm realTimeList",class:{'is400':_vm.is400,'is155':_vm.is155,'is100':_vm.is100,'is120':_vm.is120,'is600':_vm.is600,'is760':_vm.is760},attrs:{"config":_vm.config}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }